import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { BonusesSection } from './components/BonusesSection';
import { CareerSection } from './components/CareerSection';
import { CertificateSection } from './components/CertificateSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { VideoSection } from './components/VideoSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    const isProduction = window.location.hostname === 'packreiki.ebooksolutions.online';
    if (isProduction && typeof window !== 'undefined' && !(window as any).fbq) {
      const script = document.createElement('script');
      script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','2032586933980278');fbq('track','PageView');`;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2032586933980278&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen bg-[#f5ede0] text-gray-900" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BenefitsSection data-id="element-4" />
        <HowItWorksSection data-id="element-5" />
        <BonusesSection data-id="element-6" />
        <CertificateSection data-id="element-7" />
        <CareerSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <VideoSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
        <FAQSection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />
      <FloatingCTA data-id="element-17" />
    </div>;
}